import { render, staticRenderFns } from "./ClientSubPartInfo.vue?vue&type=template&id=e36aa8a8&scoped=true&"
import script from "./ClientSubPartInfo.vue?vue&type=script&lang=ts&"
export * from "./ClientSubPartInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36aa8a8",
  null
  
)

export default component.exports